/**
 * Minimal, dependency-free class-name joiner. Accepts strings, arrays and
 * conditional objects, filters falsy values, and de-duplicates whitespace.
 */
type ClassValue =
  | string
  | number
  | null
  | false
  | undefined
  | ClassValue[]
  | Record<string, boolean | null | undefined>

export function cn(...inputs: ClassValue[]): string {
  const out: string[] = []

  const walk = (value: ClassValue): void => {
    if (!value) return
    if (typeof value === "string" || typeof value === "number") {
      out.push(String(value))
      return
    }
    if (Array.isArray(value)) {
      value.forEach(walk)
      return
    }
    if (typeof value === "object") {
      for (const key in value) {
        if (value[key]) out.push(key)
      }
    }
  }

  inputs.forEach(walk)
  return out.join(" ")
}
